import { render, staticRenderFns } from "./Venta.vue?vue&type=template&id=8b428c98"
import script from "./Venta.vue?vue&type=script&lang=js"
export * from "./Venta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports